import {Component, inject} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PowerStopService} from '@core/services/power-stop.service';


@Component({
  selector: 'app-pre-order-info-message-modal',
  templateUrl: './pre-order-info-message-modal.component.html',
  styleUrls: ['./pre-order-info-message-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class PreOrderInfoMessageModalComponent {
  activeModal = inject(NgbActiveModal);
  private powerStopService = inject(PowerStopService);

  goToCheckout() {
    this.powerStopService.goToPowerStop('pre_order_info_message_modal_go_to_checkout_click');
  }
}
